export class PaginateQuery {
  page: number;
  limit: number;
  sortBy: string;
  search: string;
  filter?: {
    [column: string]: string | string[];
  };
  constructor(
    limit?: number,
    sortBy?: string,
    filter?: {
      [column: string]: string | string[];
    },
  ) {
    this.page = 1;
    this.limit = limit || 10;
    this.sortBy = sortBy || "created_at:DESC";
    this.search = "";
    if (filter) {
      this.filter = filter;
    } else {
      this.filter = {};
    }
  }
}

export class DateRangeQuery {
  from: Date;
  to: Date;
  /**
   *
   */
  constructor() {
    var date = new Date(),
      y = date.getFullYear(),
      m = date.getMonth();
    this.from = new Date(y, m, 1);
    this.to = new Date(y, m + 1, 0);
  }
}
